declare global {
  // eslint-disable-next-line
  interface Number {
    toCurrency(prefix?: string): string;
    toFormatedCurrency(currency: string): string;
    zeroFill(length: number): string;
    decimalToTime(): string;
  }
}

// eslint-disable-next-line no-extend-native
Number.prototype.zeroFill = function (length: number) {
  return this.toString().padStart(length, "0");
};

// eslint-disable-next-line no-extend-native
Number.prototype.toCurrency = function (prefix?: string) {
  const valorStr = Number(this).toFixed(2).split(".");
  const amount = valorStr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const cents = valorStr[1];
  return (prefix ? prefix + " " : "") + amount + "," + cents;
};

Number.prototype.toFormatedCurrency = function(currency: string) {
  if (!currency) return Number(this).toCurrency();
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency,
  }).format(Number(this));
}

// eslint-disable-next-line no-extend-native
Number.prototype.decimalToTime = function () {
  const hours = parseInt(this.toString());
  const minutes = (parseFloat(this.toString()) - hours) * 100.0;

  return (
    hours.toFixed(0).padStart(2, "0") +
    ":" +
    (minutes * 0.6).toFixed(0).padStart(2, "0")
  );
};

export default {};
